import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _path;

const _excluded = ["size", "title", "titleId"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';

function ExclamationTriangle(_ref) {
  let {
    size: sizeProp,
    title,
    titleId
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.797 17.75A1.5 1.5 0 0119.498 20H4.502a1.5 1.5 0 01-1.3-2.25l7.499-13a1.5 1.5 0 012.598 0l7.498 13zM12 15.062a1.438 1.438 0 100 2.876 1.438 1.438 0 000-2.875zm-1.365-5.167l.232 4.25c.01.2.175.355.374.355h1.518c.199 0 .363-.156.374-.355l.232-4.25a.375.375 0 00-.375-.395h-1.98a.375.375 0 00-.375.395z"
  })));
}

ExclamationTriangle.sizes = sizes;
ExclamationTriangle.defaultProps = {
  size: sizes.md
};
ExclamationTriangle.propTypes = {
  size: PropTypes.oneOf([ExclamationTriangle.sizes.xs, ExclamationTriangle.sizes.sm, ExclamationTriangle.sizes.md, ExclamationTriangle.sizes.lg, ExclamationTriangle.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default ExclamationTriangle;